import React, { useEffect, useRef, useState, forwardRef } from "react";
import styled from "styled-components";
import { colors } from "./colors";
import { Body2, Heading3, Heading6 } from "app/popleads/components/ui-kit/Text";
import InputWithIcon from "./Input";
import { useExtensionContext } from "app/popleads/modules/extension/ExtensionContext";
import { Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "_metronic/_helpers";
import CustomSelect from "./Select";
import { post } from "app/popleads/networking/RequestService";
import { StyledDropdownItem } from "app/popleads/modules/extension/ExtensionHome";
import useChangeProfileContactedStatus from "app/popleads/hooks/useChangeProfileContactedStatus";
import { toast } from "react-toastify";
import * as yup from "yup";
import FeatherIcon from "feather-icons-react";
import useDeleteProfileInfo from "app/popleads/hooks/useDeleteProfileInfo";
import Modal from "./Modal";

const Container = styled.div`
    display: flex;
`;

const ImageSection = styled.div`
    min-height: 81px;
    min-width: 81px;
    max-height: 81px;
    max-width: 81px;
    border-radius: 50%;
    padding: 1px;
    opacity: 1;
    background: transparent
        linear-gradient(
            90deg,
            ${colors.success[500]} 0%,
            #f6f8f914 37%,
            #f6f8f900 50%,
            #f6f8f914 63%,
            ${colors.success[500]} 100%
        )
        0% 0% no-repeat padding-box;
    text-align: center;
`;

const ImageBorder = styled.div`
    background-color: ${colors.neutral[50]};
    border-radius: 50%;
    padding: 4px;
    width: 100%;
    height: 100%;
`;
const StyledPlaceHolder = styled.span`
    color: ${colors.neutral[500]};
`;
const Image = styled.img`
    min-width: 100%;
    min-height: 100%;
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
    padding: 4px;
    border-radius: 50%;
    border: 1px solid ${colors.success[900]};
`;

const Star = styled.div`
    display: inline-block;
    height: 24px;
    width: 24px;
    background-color: #00856b;
    border-radius: 50%;
    color: #ffffff;
    position: relative;
    top: -23px;
    font-size: 18px;
    text-align: center;
    line-height: 24px;
`;

const ProfileInfo = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 12px;
    color: ${({ inActive }) => (inActive ? colors.neutral[500] : colors.neutral[800])};
    //justify-content: center;
    flex: 1;
    width: calc(81px - 100%);
    // overflow: hidden;
    gap: 2px;
`;

const Name = styled(Heading3)`
    line-height: 1.5rem;
    color: ${colors.neutral[900]};
    overflow: hidden;
    // display: -webkit-box;
    // -webkit-line-clamp: 2;
    // -webkit-box-orient: vertical;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // font-size: ${(props) => (props.isMultiline ? "16px" : "18px")};
    // max-height: 3rem;
    // width: 100%;
    // word-break: break-word;

    // span {
    //     display: -webkit-box;
    //     -webkit-line-clamp: 2;
    //     -webkit-box-orient: vertical;
    //     overflow: hidden;
    //     text-overflow: ellipsis;
    //     width: 100%;
    // }
`;

const Title = styled(Heading6)`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    cursor: default;
    gap: 2px;
    font-size: 14px;
`;

const ProfileMenu = styled.div`
    padding: 0;
    display: flex;
    align-items: center;
`;

const NameWrapper = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    overflow: hidden;

    & > span {
        display: -webkit-box !important;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        word-break: break-word;
        // display: inline-block !important;
        // overflow: hidden;
        // text-overflow: ellipsis;
        // white-space: nowrap;
    }

    &:hover {
        color: inherit;
    }
`;

const TitleWrapper = styled.div`
    display: flex;
    align-items: center;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 100%;

    &.title {
        overflow: hidden;
        max-width: 100%;
    }
`;

const EditableWrapper = styled.span`
    display: flex;
    align-items: center;
    min-width: 0;
    width: 100%;

    &.title {
        max-width: 100%;
        width: 100%;

        > span {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 100%;
            width: 100%;
        }
    }
`;
/*const StyledMailContainer = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 6px;
    align-items: center;
    position: relative;
    svg {
        color: ${colors.neutral[800]};
    }
`;
const InfoText = styled(Body2)`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 0 0 91%;
    max-width: 91%;
`;*/
const InfoEmailText = styled(Body2)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    font-size: 14px;

    span {
        flex: 1;
        overflow: visible;
        text-overflow: unset;
        white-space: normal;
    }
`;
const InfoPhoneText = styled(Body2)`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    font-size: 14px;

    span {
        flex: 1;
        overflow: visible;
        text-overflow: unset;
        white-space: normal;
    }
`;

const DeleteButton = styled.button`
    width: 20px;
    height: 20px;
    padding: 0;
    margin: 0;
    border: none;
    background: none;
    color: ${colors.danger[500]};
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 8px;
    opacity: 1;
    transition: all 0.2s;
    border-radius: 50%;

    &:hover {
        background-color: ${colors.danger[100]};
        opacity: 1;
    }

    &:focus {
        outline: none;
    }

    svg {
        width: 12px;
        height: 12px;
        fill: ${colors.danger[500]};
    }

    .material-symbols-outlined {
        font-size: 16px;
        color: ${colors.danger[500]};
    }
`;
const MoreButton = styled.button`
    width: 24px;
    height: 24px;
    padding: 0;
    margin: 0;
    border: none;
    color: ${colors.neutral[700]};
    background-color: transparent;
`;

export const StyledDropdownToggle = styled(Dropdown.Toggle)`
    height: 21px !important;
    min-width: 24px !important;
    background: none !important;
    border: none !important;
    padding: 0 !important;
    color: inherit !important;
    box-shadow: none !important;

    &:hover,
    &:active,
    &:focus {
        background: none !important;
        border: none !important;
        box-shadow: none !important;
        color: inherit !important;
    }

    &:after {
        display: none !important;
    }
`;

const StyledDropdownMenu = styled(Dropdown.Menu)`
    padding: 8px;
    min-width: 180px;
    max-width: max-content;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    border: 1px solid ${colors.neutral[200]};
    top: -1px !important;

    .dropdown-item {
        border-radius: 4px;
        padding: 8px 12px;
        font-size: 14px;

        &:hover {
            background-color: ${colors.neutral[100]};
        }

        &:active {
            background-color: ${colors.primary[100]};
            color: ${colors.primary[700]};
        }
    }

    .dropdown-divider {
        margin: 4px 0;
        border-color: ${colors.neutral[200]};
    }
`;

const StyledTooltip = styled(Tooltip)`
    .tooltip-inner {
        font-size: 11px !important;
    }
`;
/*const MailIconWrapper = styled.span`
    display: flex;
    align-items: center;
`;*/

const ProfileCard = forwardRef(({ variant, ...props }, ref) => {
    const { profile, setProfile, setState, urlParams, refetchProfile } = useExtensionContext();
    const fallbackSrc = "/media/users/default.jpg";
    const [isHidden, setIsHidden] = useState("");
    const [isMultiline, setIsMultiline] = useState(false);
    const nameRef = useRef(null);
    const [show, setShow] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [itemToDelete, setItemToDelete] = useState(null);

    const { changeContactedStatus } = useChangeProfileContactedStatus();
    const { deleteProfileInfo, loading: deleteLoading } = useDeleteProfileInfo();

    const handleContactedStatus = async (status) => {
        setShow(false);
        if (profile?.contactStatus === status) return;
        const response = await changeContactedStatus({ profileId: profile?.id, status });
        if (response.error) {
            toast.error(response.error);
        } else {
            toast.success("Contacted status changed successfully");
            setProfile((prevProfile) => ({ ...prevProfile, contactStatus: status }));
        }
    };

    const checkMultiline = () => {
        if (nameRef.current) {
            const nameSpan = nameRef.current.querySelector("span");
            if (nameSpan) {
                const spanHeight = nameSpan.offsetHeight;
                const lineHeight = parseInt(getComputedStyle(nameSpan).lineHeight);
                setIsMultiline(spanHeight > lineHeight);
            }
        }
    };

    useEffect(() => {
        checkMultiline();
        window.addEventListener("resize", checkMultiline);
        return () => window.removeEventListener("resize", checkMultiline);
    }, [profile?.ad, profile?.soyad]);

    const getLinkedinUsername = (site) => {
        if (!site) return "";
        const newUrl = site[site.length - 1] === "/" ? site.slice(0, -1) : site;
        return newUrl.replace("https://www.linkedin.com/in/", "");
    };

    const FIELD_NAMES = {
        ad: "Name",
        site: "Linkedin URL",
        resim: "Image",
        baslik: "Title",
        sirket: "Company",
        country: "City/Country",
    };

    const compareLinkedinUrls = (url1, url2) => {
        const username1 = getLinkedinUsername(url1);
        const username2 = getLinkedinUsername(url2);
        return username1 === username2;
    };

    const fullName = profile?.ad && profile?.soyad ? `${profile?.ad} ${profile?.soyad}` : profile?.ad || profile?.soyad;
    const cityAndCountry = profile?.city ? `${profile?.city}, ${profile?.country}` : profile?.country;

    const hasPhoneValue = (value) => {
        return value !== null && value !== undefined && value !== "" && String(value).trim() !== "";
    };

    const handleDeleteClick = (field, value) => {
        setItemToDelete({ field, value });
        setShowDeleteModal(true);
    };

    const handleRemove = async () => {
        if (!itemToDelete || !profile?.id) {
            setShowDeleteModal(false);
            setItemToDelete(null);
            return;
        }

        try {
            const result = await deleteProfileInfo({
                profileId: profile.id,
                param: itemToDelete.field,
                paramValue: itemToDelete.value,
            });

            setShowDeleteModal(false);
            setItemToDelete(null);

            if (result && !result.error) {
                toast.success("Contact information deleted successfully");
                if (refetchProfile) {
                    await refetchProfile();
                }
            } else {
                toast.error(result?.error || "Failed to delete contact information");
            }
        } catch (error) {
            setShowDeleteModal(false);
            setItemToDelete(null);
            toast.error("Failed to delete contact information");
        }
    };

    const hasChanges =
        (urlParams?.profil_ad !== undefined &&
            urlParams?.profil_ad !== null &&
            urlParams?.profil_ad?.toLowerCase() !== fullName?.normalize()?.toLowerCase()) ||
        (urlParams?.profil_baslik !== undefined &&
            urlParams?.profil_baslik !== null &&
            urlParams?.profil_baslik !== profile?.baslik) ||
        (urlParams?.profil_sirket !== undefined &&
            urlParams?.profil_sirket !== null &&
            urlParams?.profil_sirket !== profile?.sirket) ||
        (urlParams?.profil_ulke !== undefined &&
            urlParams?.profil_ulke !== null &&
            urlParams?.profil_ulke !== cityAndCountry) ||
        (urlParams?.profil_tel !== undefined &&
            urlParams?.profil_tel !== null &&
            urlParams?.profil_tel !== profile?.tel) ||
        (urlParams?.profil_email !== undefined &&
            urlParams?.profil_email !== null &&
            urlParams?.profil_email !== profile?.email);

    const renderWarningIcon = (field, value, tooltip) => {
        if (value === undefined || value === null) return null;
        return (
            <OverlayTrigger placement="top" overlay={<StyledTooltip>{tooltip}</StyledTooltip>}>
                <div
                    style={{ cursor: "pointer", display: "inline-flex" }}
                    onClick={() =>
                        setState({
                            popupContent: "About",
                            selectedModal: "updateProfile",
                            fieldToUpdate: { field, value },
                        })
                    }
                >
                    <SVG src={toAbsoluteUrl("/media/svg/popleads/warning2.svg")} />
                </div>
            </OverlayTrigger>
        );
    };

    return (
        <Container {...props} ref={ref}>
            <ImageSection>
                <ImageBorder style={{ position: "relative" }}>
                    <Image
                        src={
                            urlParams?.profil_resim && !urlParams?.profil_resim.startsWith("data:image")
                                ? urlParams?.profil_resim
                                : profile?.resim || fallbackSrc
                        }
                        alt="profile"
                        onError={(e) => (e.currentTarget.src = fallbackSrc)}
                    />
                </ImageBorder>
                {profile?.dealsWonCount > 0 && (
                    <OverlayTrigger
                        key="bottom"
                        placement="bottom"
                        overlay={
                            <StyledTooltip id={`tooltip-bottom`}>
                                <strong>{`Has ${profile?.dealsWonCount} Won ${
                                    profile?.dealsWonCount < 2 ? "Deal" : "Deals"
                                }`}</strong>
                            </StyledTooltip>
                        }
                    >
                        {<Star className="material-symbols-outlined">star</Star>}
                    </OverlayTrigger>
                )}
            </ImageSection>
            <ProfileInfo inActive={variant === "neutralInActive"}>
                <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                    <Name ref={nameRef} isMultiline={isMultiline}>
                        <NameWrapper as={"a"} href="#" onClick={(e) => e.preventDefault()}>
                            <EditableWrapper>
                                {profile ? (
                                    <EditableField
                                        value={fullName}
                                        field="ad"
                                        tooltip={`Full Name`}
                                        validationSchema={yup
                                            .string()
                                            .required("Full name is required")
                                            .test(
                                                "two-words",
                                                "Full name must contain at least two words",
                                                (value) => value && value.trim().split(/\s+/).length >= 2
                                            )
                                            .max(140, "Full name must be at most 140 characters")}
                                    />
                                ) : urlParams?.profil_ad ? (
                                    urlParams?.profil_ad
                                ) : (
                                    "Not available"
                                )}
                            </EditableWrapper>
                            {variant === "neutralInActive" &&
                                urlParams?.profil_ad?.toLowerCase() !== fullName?.normalize()?.toLowerCase() &&
                                renderWarningIcon(
                                    "ad",
                                    urlParams?.profil_ad,
                                    `Changed to ${urlParams?.profil_ad}, click to apply changes`
                                )}
                        </NameWrapper>
                    </Name>
                    {variant !== "neutralInActive" && profile ? (
                        <div>
                            <ProfileMenu>
                                {hasChanges && (
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={<StyledTooltip>Profile has changes to apply</StyledTooltip>}
                                    >
                                        <div
                                            style={{ cursor: "pointer" }}
                                            onClick={() => setState({ popupContent: "About" })}
                                        >
                                            <SVG src={toAbsoluteUrl("/media/svg/popleads/warning2.svg")} />
                                        </div>
                                    </OverlayTrigger>
                                )}
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<StyledTooltip className="text-capitalize">About</StyledTooltip>}
                                >
                                    <MoreButton
                                        onClick={() => {
                                            setState({
                                                popupContent: "About",
                                                selectedModal: null,
                                                itemToDelete: null,
                                            });
                                        }}
                                    >
                                        <span className="material-symbols-outlined">more_vert</span>
                                    </MoreButton>
                                </OverlayTrigger>
                                <Dropdown
                                    onMouseEnter={() => setShow(true)}
                                    onMouseLeave={() => setShow(false)}
                                    show={show}
                                >
                                    <StyledDropdownToggle id="profile-actions-dropdown">
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <StyledTooltip className="text-capitalize">
                                                    {profile?.contactStatus}
                                                </StyledTooltip>
                                            }
                                        >
                                            <span>
                                                {profile?.contactStatus === "Contacted" ? (
                                                    <SVG src={toAbsoluteUrl("/media/svg/popleads/phone-success.svg")} />
                                                ) : profile?.contactStatus === "Not Reached" ? (
                                                    <SVG
                                                        style={{
                                                            fill: "#F0A1A1",
                                                            stroke: "#F0A1A1",
                                                        }}
                                                        src={toAbsoluteUrl("/media/svg/popleads/phone-missed.svg")}
                                                    />
                                                ) : profile?.contactStatus === "Not Contacted" ? (
                                                    <SVG src={toAbsoluteUrl("/media/svg/popleads/phone-off.svg")} />
                                                ) : null}
                                            </span>
                                        </OverlayTrigger>
                                    </StyledDropdownToggle>
                                    <StyledDropdownMenu>
                                        <StyledDropdownItem
                                            onClick={() => {
                                                handleContactedStatus("Contacted");
                                            }}
                                        >
                                            <SVG src={toAbsoluteUrl("/media/svg/popleads/phone-success.svg")} />
                                            Contacted
                                        </StyledDropdownItem>
                                        <StyledDropdownItem
                                            onClick={() => {
                                                handleContactedStatus("Not Reached");
                                            }}
                                        >
                                            <SVG
                                                style={{
                                                    fill: "#F0A1A1",
                                                    stroke: "#F0A1A1",
                                                }}
                                                src={toAbsoluteUrl("/media/svg/popleads/phone-missed.svg")}
                                            />
                                            Not Reached
                                        </StyledDropdownItem>
                                        <StyledDropdownItem
                                            onClick={() => {
                                                handleContactedStatus("Not Contacted");
                                            }}
                                        >
                                            <SVG src={toAbsoluteUrl("/media/svg/popleads/phone-off.svg")} />
                                            Not Contacted
                                        </StyledDropdownItem>
                                    </StyledDropdownMenu>
                                </Dropdown>
                            </ProfileMenu>
                        </div>
                    ) : null}
                </div>
                {variant === "neutralInActive" ? (
                    <Title
                        style={{ display: "flex", alignItems: "center", gap: "8px", justifyContent: "space-between" }}
                    >
                        {profile ? (
                            <EditableField
                                placeholder={!profile?.site && "Edit LinkedIn URL"}
                                value={getLinkedinUsername(profile?.site)}
                                field="site"
                                prefix="/in/"
                                showFullUrlInEdit={true}
                                tooltip={`LinkedIn URL: /in/${getLinkedinUsername(profile?.site)}`}
                            />
                        ) : (
                            getLinkedinUsername(urlParams?.profil_url)
                        )}

                        {/* <span>{profile?.site ? getLinkedinUsername(profile?.site) : "-"}</span> */}
                        {!compareLinkedinUrls(urlParams?.profil_url, profile?.site) &&
                            renderWarningIcon("site", urlParams?.profil_url, `Changed to ${FIELD_NAMES.site}`)}
                    </Title>
                ) : (
                    <>
                        <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                            <Title style={{ width: profile?.site ? "calc(100% - 17px)" : "100%" }}>
                                {isHidden !== "sirket" && (
                                    <TitleWrapper className={isHidden === "baslik" ? "" : "title"}>
                                        {profile ? (
                                            <EditableWrapper
                                                className={isHidden === "baslik" ? "" : "title"}
                                                onClick={() => setIsHidden("baslik")}
                                            >
                                                <EditableField
                                                    value={profile?.sirket}
                                                    field="sirket"
                                                    setIsHidden={setIsHidden}
                                                    inputType="select"
                                                    tooltip={`Account Name`}
                                                />
                                            </EditableWrapper>
                                        ) : (
                                            <div
                                                style={{
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                }}
                                            >
                                                {urlParams?.profil_sirket ? urlParams?.profil_sirket : "Not available"}
                                            </div>
                                        )}
                                    </TitleWrapper>
                                )}
                                {isHidden !== "baslik" && (
                                    <TitleWrapper className={isHidden === "sirket" ? "" : "title"}>
                                        {profile ? (
                                            <EditableWrapper className="title" onClick={() => setIsHidden("sirket")}>
                                                <EditableField
                                                    value={profile?.baslik}
                                                    field="baslik"
                                                    tooltip={`Title`}
                                                    setIsHidden={setIsHidden}
                                                    validationSchema={yup
                                                        .string()
                                                        .max(150, "Title must be at most 150 characters")}
                                                />
                                            </EditableWrapper>
                                        ) : (
                                            <div
                                                style={{
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                }}
                                            >
                                                {urlParams?.profil_baslik ? urlParams?.profil_baslik : "Not available"}
                                            </div>
                                        )}
                                    </TitleWrapper>
                                )}
                            </Title>
                            {profile?.site && (
                                <OverlayTrigger
                                    placement="top"
                                    overlay={<StyledTooltip>Open LinkedIn Profile</StyledTooltip>}
                                >
                                    <a
                                        href={profile?.site}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ lineHeight: "0" }}
                                    >
                                        <FeatherIcon icon="linkedin" size={17} />
                                    </a>
                                </OverlayTrigger>
                            )}
                        </div>
                        {profile ? (
                            <>
                                {profile.email && (
                                    <InfoEmailText>
                                        <EditableField
                                            placeholder={!profile?.email && "Add Email"}
                                            value={profile?.email}
                                            field="email"
                                            tooltip={`Email`}
                                            validationSchema={yup
                                                .string()
                                                .email("Invalid email format")
                                                .max(140, "Email must be at most 140 characters")}
                                        />
                                        <DeleteButton
                                            onClick={() => handleDeleteClick("email", profile?.email)}
                                            title="Delete email"
                                        >
                                            <span className="material-symbols-outlined">close</span>
                                        </DeleteButton>
                                    </InfoEmailText>
                                )}
                                {profile.email2 && (
                                    <InfoEmailText>
                                        <EditableField
                                            placeholder={!profile?.email2 && "Second Email"}
                                            value={profile?.email2}
                                            field="email2"
                                            tooltip={`Second Email`}
                                            validationSchema={yup
                                                .string()
                                                .email("Invalid email format")
                                                .max(140, "Email must be at most 140 characters")}
                                        />
                                        <DeleteButton
                                            onClick={() => handleDeleteClick("email2", profile?.email2)}
                                            title="Delete email"
                                        >
                                            <span className="material-symbols-outlined">close</span>
                                        </DeleteButton>
                                    </InfoEmailText>
                                )}
                                {!profile?.email && !profile?.email2 && (
                                    <InfoEmailText>
                                        <EditableField
                                            placeholder="Add Email"
                                            value=""
                                            field="email"
                                            tooltip=""
                                            validationSchema={yup
                                                .string()
                                                .email("Invalid email format")
                                                .max(140, "Email must be at most 140 characters")}
                                        />
                                    </InfoEmailText>
                                )}
                            </>
                        ) : urlParams?.profil_email ? (
                            <InfoEmailText>{urlParams?.profil_email}</InfoEmailText>
                        ) : (
                            <InfoEmailText>No email available</InfoEmailText>
                        )}
                        {profile ? (
                            <>
                                {hasPhoneValue(profile.tel) && (
                                    <InfoPhoneText>
                                        <EditableField
                                            placeholder={!profile?.tel && "Mobile Phone"}
                                            value={profile?.tel}
                                            field="tel"
                                            tooltip={`Mobile Phone`}
                                            validationSchema={yup
                                                .string()
                                                .max(140, "Phone number must be at most 140 characters")}
                                        />
                                        <DeleteButton
                                            onClick={() => handleDeleteClick("tel", profile?.tel)}
                                            title="Delete phone"
                                        >
                                            <span className="material-symbols-outlined">close</span>
                                        </DeleteButton>
                                    </InfoPhoneText>
                                )}
                                {hasPhoneValue(profile.tel2) && (
                                    <InfoPhoneText>
                                        <EditableField
                                            placeholder={!profile?.tel2 && "Add Phone"}
                                            value={profile?.tel2}
                                            field="tel2"
                                            tooltip={`Add Phone`}
                                            validationSchema={yup
                                                .string()
                                                .max(140, "Phone number must be at most 140 characters")}
                                        />
                                        <DeleteButton
                                            onClick={() => handleDeleteClick("tel2", profile?.tel2)}
                                            title="Delete phone"
                                        >
                                            <span className="material-symbols-outlined">close</span>
                                        </DeleteButton>
                                    </InfoPhoneText>
                                )}
                                {hasPhoneValue(profile.tel3) && (
                                    <InfoPhoneText>
                                        <EditableField
                                            placeholder={!profile?.tel3 && "Other Phone"}
                                            value={profile?.tel3}
                                            field="tel3"
                                            tooltip={`Other Phone`}
                                            validationSchema={yup
                                                .string()
                                                .max(140, "Phone number must be at most 140 characters")}
                                        />
                                        <DeleteButton
                                            onClick={() => handleDeleteClick("tel3", profile?.tel3)}
                                            title="Delete phone"
                                        >
                                            <span className="material-symbols-outlined">close</span>
                                        </DeleteButton>
                                    </InfoPhoneText>
                                )}
                                {!hasPhoneValue(profile.tel) &&
                                    !hasPhoneValue(profile.tel2) &&
                                    !hasPhoneValue(profile.tel3) && (
                                        <InfoPhoneText>
                                            <EditableField
                                                placeholder="Add Phone"
                                                value=""
                                                field="tel"
                                                tooltip=""
                                                validationSchema={yup
                                                    .string()
                                                    .max(140, "Phone number must be at most 140 characters")}
                                            />
                                        </InfoPhoneText>
                                    )}
                            </>
                        ) : urlParams?.profil_tel ? (
                            <InfoPhoneText>{urlParams?.profil_tel}</InfoPhoneText>
                        ) : (
                            <InfoPhoneText>No phone available</InfoPhoneText>
                        )}
                    </>
                )}
            </ProfileInfo>
            <Modal
                isOpen={showDeleteModal}
                onClose={() => setShowDeleteModal(false)}
                title={itemToDelete?.field?.includes("email") ? "Delete Email" : "Delete Phone Number"}
                variant="danger"
                icon="delete"
                successButtonText={deleteLoading ? "Deleting..." : "Yes, Delete"}
                cancelButtonText="Not Now"
                onSuccess={handleRemove}
            >
                <div>
                    {itemToDelete?.field?.includes("email")
                        ? "Are you sure you want to delete this email?"
                        : "Are you sure you want to delete this phone number?"}
                </div>
                <div style={{ margin: "8px 0", fontWeight: "600" }}>{itemToDelete?.value}</div>
                <div>This action cannot be undone.</div>
            </Modal>
        </Container>
    );
});

export default ProfileCard;

export function EditableField({
    value,
    onChange,
    field,
    setIsHidden,
    inputType,
    placeholder,
    validationSchema,
    prefix,
    tooltip = "",
    showFullUrlInEdit = false,
    onFocus,
    ...props
}) {
    const [isEditing, setIsEditing] = useState(false);
    const wrapperRef = useRef(null);
    const { handleUpdateProfile, setState, modals } = useExtensionContext();
    const [inputValue, setInputValue] = useState(value);
    const [selectedOption, setSelectedOption] = useState({ value, label: value });

    const fetchQuery = async (inputValue, page) => {
        const requestObj = {
            fn: "getAccountSuggestions",
            accountName: inputValue ? inputValue : value,
            page: page,
            pageSize: 100,
        };

        try {
            const response = await post(requestObj);
            const data = response.data;
            const options = data?.accounts?.map((item) => {
                return {
                    value: item.accountName,
                    label: item.accountName,
                };
            });

            return {
                options,
                hasMore: data.totalCount ? page * 100 < data.totalCount : false,
                additional: {
                    page: page + 1,
                },
            };
        } catch (error) {
            // console.error("Error fetching data:", error);
            return {
                options: [],
                hasMore: false,
                additional: {
                    page: 1,
                },
            };
        }
    };

    const loadOptions = (inputValue, _, { page }) =>
        new Promise((resolve) => {
            const options = fetchQuery(inputValue, page);
            resolve(options);
        });

    const handleSubmit = () => {
        const newValue = inputValue?.trim();

        if (!newValue || newValue === value) {
            setInputValue(value); // değer değişmediyse orijinal değere geri dön
            setSelectedOption({ value, label: value });
            setIsEditing(false);
            if (setIsHidden) setIsHidden("");
            return;
        }

        if (validationSchema) {
            validationSchema
                .validate(newValue)
                .then(() => {
                    handleUpdateProfile({ field: field, fieldValue: newValue });
                    setIsEditing(false);
                    if (setIsHidden) setIsHidden("");
                })
                .catch((err) => {
                    toast.error(err.message);
                    setIsEditing(true);
                    //setInputValue(value); // hata varsa orijinal değere geri dön
                    //setSelectedOption({ value, label: value });
                    //setIsEditing(false);
                    //if (setIsHidden) setIsHidden("");
                });
        } else {
            if (field === "site") {
                setState((prevState) => ({
                    ...prevState,
                    selectedModal: modals.LINKEDIN_URL_UPDATE,
                    updateProfileParams: {
                        field: field,
                        fieldValue: newValue,
                    },
                }));
                setInputValue(value);
            } else {
                handleUpdateProfile({ field: field, fieldValue: newValue }); // Parent bileşene değişikliği bildir
            }
            setIsEditing(false);
            if (setIsHidden) setIsHidden("");
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            const menuPortal = document.getElementById("newFilterMenu");
            const toastContainer = document.querySelector(".Toastify__toast-container");

            if (
                isEditing &&
                wrapperRef.current &&
                !wrapperRef.current.contains(event.target) &&
                !menuPortal?.contains(event.target) &&
                !toastContainer?.contains(event.target)
            ) {
                setInputValue(value);
                setSelectedOption({ value, label: value });
                setIsEditing(false);
                if (setIsHidden) setIsHidden("");
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isEditing, inputValue, value, onChange, field, handleUpdateProfile]);

    useEffect(() => {
        setInputValue(value);
        setSelectedOption({ value, label: value });
    }, [value]);

    useEffect(() => {
        if (isEditing && inputType !== "select") {
            const input = wrapperRef.current.querySelector("input");
            input.focus();
        }
    }, [isEditing]);

    return (
        <span ref={wrapperRef} style={{ cursor: "pointer", width: "100%" }}>
            {isEditing ? (
                inputType === "select" ? (
                    <div style={{ minWidth: "213px" }}>
                        <CustomSelect
                            key="profile-single-select"
                            // options={options}
                            unstyled={true}
                            value={selectedOption}
                            isClearable={false}
                            isSearchable={true}
                            isCreatable={true}
                            onChange={(selection) => {
                                setSelectedOption(selection);
                                setInputValue(selection?.value);
                            }}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    e.preventDefault();
                                    setIsEditing(false);
                                    if (setIsHidden) setIsHidden("");
                                    handleSubmit();
                                } else if (e.key === "Escape") {
                                    e.preventDefault();
                                    setInputValue(value);
                                    setSelectedOption({ value, label: value });
                                    setIsEditing(false);
                                    if (setIsHidden) setIsHidden("");
                                }
                            }}
                            isMulti={false}
                            placeholder={"Creatable Async Selection..."}
                            loadOptions={loadOptions}
                            additional={{ page: 1 }}
                            menuPlacement={props.menuPlacement || "auto"}
                            onMenuOpen={props.onMenuOpen}
                            onFocus={onFocus}
                        />
                    </div>
                ) : showFullUrlInEdit && field === "site" ? (
                    <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
                        <span style={{ color: colors.neutral[600], whiteSpace: "nowrap" }}>linkedin.com/in/</span>
                        <InputWithIcon
                            variant={"unstyled"}
                            placeholder={placeholder}
                            debounceTime={0}
                            value={inputValue || ""}
                            onChange={(e) => setInputValue(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    e.preventDefault();
                                    setIsEditing(false);
                                    if (setIsHidden) setIsHidden("");
                                    handleSubmit();
                                } else if (e.key === "Escape") {
                                    e.preventDefault();
                                    setInputValue(value);
                                    setIsEditing(false);
                                    if (setIsHidden) setIsHidden("");
                                }
                            }}
                            onFocus={onFocus}
                            style={{ minWidth: "100px", flex: 1 }}
                        />
                    </div>
                ) : (
                    <InputWithIcon
                        variant={"unstyled"}
                        placeholder={placeholder}
                        debounceTime={0}
                        value={inputValue || ""}
                        onChange={(e) => setInputValue(e.target.value)}
                        onFocus={onFocus}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault();
                                setIsEditing(false);
                                if (setIsHidden) setIsHidden("");
                                handleSubmit();
                            } else if (e.key === "Escape") {
                                e.preventDefault();
                                setInputValue(value);
                                setIsEditing(false);
                                if (setIsHidden) setIsHidden("");
                            }
                        }}
                    />
                )
            ) : (
                <span onClick={() => setIsEditing(true)}>
                    {value && prefix && <span>{prefix}</span>}
                    {value ? (
                        tooltip === "" ? (
                            value
                        ) : (
                            <OverlayTrigger placement="top" overlay={<StyledTooltip>{tooltip}</StyledTooltip>}>
                                <span>{value}</span>
                            </OverlayTrigger>
                        )
                    ) : (
                        <StyledPlaceHolder>{placeholder}</StyledPlaceHolder>
                    )}
                </span>
            )}
        </span>
    );
}
